export default {
  computed: {
    buttonText () {
      if (!this.available) {
        return this.t('product_status.unavailable.coming_soon')
      }

      if (this.progress) {
        return `${this.t('product_status.progress')}...`
      }

      if (!this.onlineStatus) {
        return `<i class="icon-energy icons"></i>${this.t('online_status.offline')}`
      }

      return this.t('add_to_cart')
    },
    disabled () {
      return this.quantity < 1 || !this.onlineStatus || !this.available || this.progress
    },
    available () {
      return this.stock > 0 && !this.unavailable
    }
  }
}
